<div class="container container--mobile">
  <div class="contenedor-datos-basicos" [ngSwitch]="mostrarAlerta">
    <div *ngSwitchCase="'espera'" class="contenedor-alert">
      <div class="contenedor-img">
        <img src="../../../../assets/img/LogoApprobe.gif" alt="apploader" />
      </div>
      <p class="text-alert">
        Espera un momento, estamos validando tu información
      </p>
    </div>
    <div *ngSwitchCase="'fallo'" class="contenedor-alert">
      <div class="contenedor-img">
        <img src="../../../../assets/img/error-alert.svg" alt="erroralert" />
      </div>
      <p class="title-error">Algo no salió bien</p>
      <p class="text-alert">No fue posible validar tu identidad</p>
      <button class="btn btn-azul btn-redondo" (click)="navigateToClient()">
        Volver al comercio
      </button>
    </div>

    <div *ngSwitchCase="'rechazado'" class="contenedor-alert">
      <div class="contenedor-img">
        <img src="../../../../assets/img/error-alert.svg" alt="erroralert" />
      </div>
      <p class="title-error">Cupo rechazado</p>
      <p class="text-alert">
        Esta vez no lo logramos, te esperamos en una próxima oportunidad.
      </p>
      <button class="btn btn-azul btn-redondo" (click)="navigateToClient()">
        Volver al comercio
      </button>
    </div>

    <div *ngSwitchCase="'ultimopaso'" class="contenedor-alert-ultimopaso">
      <div class="contenedor-img">
        <img
          style="width: 90%"
          src="../../../../assets/img/paso-a-paso.svg"
          alt="pasoapaso"
        />
      </div>
      <p class="title-error">Te falta un último paso para decir ¡Approbe!</p>
      <p class="text-alert">Valida y firma los documentos</p>
      <button class="btn btn-azul btn-redondo" (click)="useFunction()">
        ¡Vamos!
      </button>
    </div>

    <div *ngSwitchCase="'felicidades'" class="contenedor-felicidades">
      <div class="contenedor-felicitaciones">
        <div>
          <p class="titlecupo">¡Felicitaciones!</p>
          <div *ngIf="isScreenLarge">
            <p class="cupaprobado">
              {{ name }}, tu <b>cupo fue aprobado </b>por:
            </p>
          </div>
          <div *ngIf="!isScreenLarge">
            <p class="cupaprobado">{{ name }},</p>
            <p class="cupaprobado">tu <b>cupo fue aprobado </b>por:</p>
          </div>
          <p class="ammountaprobado">
            {{ amountFinance | currency : "USD" : "symbol" : "1.0-0" }}
          </p>
        </div>
        <img src="../../../../assets/img/success.svg" alt="success" />
      </div>
      <div class="contenedor-planear">
        <p class="link-style">¿Cuando planeas usar tu cupo?</p>
        <div class="contenedor-botones">
          <a (click)="enableMasAdelante()" class="link-style">Más adelante</a>
          <button
            class="btn-felicidades btn-redondo-felicidades"
            (click)="navigateToUseCupo()"
          >
            ¡YA!
          </button>
        </div>
      </div>
    </div>

    <div *ngSwitchCase="'masadelante'" class="contenedor-masadelante">
      <div class="contenedor-img-masadelante">
        <img src="../../../../assets/img/success.svg" alt="succes" />
        <div class="contenedor-cupo-aprobado">
          <p class="ammountaprobado-masadelante">
            {{ amountFinance | currency : "USD" : "symbol" : "1.0-0" }}
          </p>
          <p class="cupaprobado-masadelante">Cupo aprobado</p>
        </div>
        <p class="cliente-aprobado">{{ name }}, usa tu cupo</p>
        <p class="cliente-opciones">¡Tenemos miles de opciones para ti!</p>
      </div>
      <button (click)="navigateToClient()" class="btn btn-azul btn-redondo">
        ¡Compra aquí!
      </button>
    </div>

    <div *ngSwitchCase="'nocupo'">
      <div class="contenedor-img">
        <img src="../../../../assets/img/error-alert.svg" alt="erroralert" />
      </div>
      <div class="contenedor-mensaje-error">
        <p class="title-error">No cuentas con cupo disponible</p>
        <p class="text-alert">
          Esta vez no lo logramos, te esperamos en una próxima oportunidad.
        </p>
        <button class="btn btn-azul btn-redondo" (click)="navigateToClient()">
          Volver al comercio
        </button>
        <p class="communication-message">
          Si tienes dudas sobre tu crédito, contáctanos por correo a
          cartera"&#64;"approbe.co o por teléfono a nuestra línea directa +57
          3164740252.
        </p>
      </div>
    </div>

    <div *ngSwitchCase="'saliomal'" class="contenedor-alert">
      <div class="contenedor-img">
        <img src="../../../../assets/img/error-alert.svg" alt="erroralert" />
      </div>
      <p class="title-error">Algo no salió bien</p>
      <p class="text-alert">No fue posible validar tu identidad</p>
      <button class="btn btn-azul btn-redondo" (click)="navigateToBasicData()">
        Volver a validar
      </button>
    </div>
  </div>

  <section *ngIf="mostrarAlerta == 'rechazado'" class="container--soporte">
    <div class="container--soporte--aviso">
      <img src="../../../../assets/img/approbe.png" alt="logoapprobe" />
      <p>Hola, ¿Validamos si tienes una segunda oportunidad?</p>
    </div>
    <img
      (click)="redirectWhatsapp()"
      class="whatsapp"
      src="../../../../assets/img/whatsapp.png"
      alt="whatsapp"
    />
  </section>
</div>

<section
  *ngIf="mostrarAlerta == 'error'"
  class="contenedor-alert contenedor-alert-error contenedor--alert--style"
>
  <img [src]="dataNavigate.img" [alt]="dataNavigate.altImg" />
  <section>
    <p class="text--style--error">{{ dataNavigate.description }}</p>
  </section>
  <section>
    <button
      *ngIf="dataNavigate.button != ''"
      class="btn btn-azul btn-redondo"
      (click)="executeFunction(dataNavigate.runFunction)"
    >
      {{ dataNavigate.nameButton }}
    </button>
  </section>
</section>

<section
  *ngIf="mostrarAlerta == 'error-connection'"
  class="contenedor-alert contenedor-alert-error contenedor--alert--style"
>
  <img
    src="../../../../assets/img/connection-failed.png"
    alt="Error de Conexión"
  />
  <section>
    <p class="text--style--error">
      Error interno del servidor, ¡intenta mas tarde!
    </p>
  </section>
  <section>
    <button class="btn btn-azul btn-redondo" (click)="navigateToClient()">
      Volver al comercio
    </button>
  </section>
</section>

<section
  *ngIf="mostrarAlerta == 'evidente'"
  class="contenedor-alert contenedor-alert-error contenedor--alert--style"
>
  <img src="../../../../assets/img/paso-a-paso.svg" alt="Alerta de error" />
  <section>
    <p class="text--style--error">
      ¡Hola! Por ahora, no podemos continuar con el proceso. Vamos a hacer
      algunas validaciones y te contactaremos pronto para seguir adelante.
      ¡Gracias por tu paciencia!
    </p>
    <p class="text--style--error">
      Saludos, El equipo de
      <img
        src="https://image-bnpl-prod.s3.us-east-1.amazonaws.com/APR.png"
        alt="Approbe"
      />
      (431)
    </p>
  </section>
</section>
